
// import React, { useState, useEffect } from "react";
// import Route from "./Routes/routeIndex";
// import { CookieConsent } from "react-cookie-consent";
// import "./assets/scss/theme.scss";
// import { useNavigate } from "react-router-dom";

// function App() {
//   const navigate = useNavigate();
//   // State to track cookie preferences
//   const [cookiesAccepted, setCookiesAccepted] = useState(false);
//   const [analyticsAccepted, setAnalyticsAccepted] = useState(false);

//   // Function to set cookies using document.cookie
//   const setCookie = (name, value) => {
//     document.cookie = `${name}=${value}; path=/; max-age=31536000`; // max-age 1 year
//   };

//   const deleteCookie = (name) => {
//     document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
//   };

//   // Handle user consent
//   const handleAccept = () => {
//     setCookie("cookieConsent", "true");
//     setCookie("analyticsConsent", "true");
//     setCookiesAccepted(true);
//     setAnalyticsAccepted(true);
//   };

//   const handleDecline = () => {
//     setCookie("cookieConsent", "true");
//     setCookie("analyticsConsent", "false");
//     setCookiesAccepted(true);
//     setAnalyticsAccepted(false);
//   };

//   // Reset cookie preferences and show the banner again
//   const resetCookiePreferences = () => {
//     deleteCookie("tenergiaUserConsent");  // Delete the cookie used by react-cookie-consent
//     setCookiesAccepted(false); // Reset state to show banner
//     setAnalyticsAccepted(false);
//     window.location.reload(false);
//   };

//   useEffect(() => {
//     // Check if cookies are already accepted by checking cookies
//     const storedConsent = document.cookie.split("; ").find(row => row.startsWith("tenergiaUserConsent"));

//     if (storedConsent) {
//       setCookiesAccepted(true);
//     }
//   }, []);

//   return (
//     <React.Fragment>
//       <Route />
      
//       {/* The Cookie Consent Banner */}
//       <CookieConsent
//         location="bottom"
//         style={{
//           background: "#2b373b",
//           color: "#ffffff",
//           padding: "20px",
//           fontSize: "16px",
//         }}
//         buttonStyle={{
//           background: "#f4d03f",
//           color: "#2b373b",
//           borderRadius: "5px",
//           padding: "10px 20px",
//           fontWeight: "bold",
//         }}
//         cookieName="tenergiaUserConsent"  // This is the cookie name that the component uses
//         expires={1} // Cookie expires in 1 day
//         buttonText="Accetto"
//         declineButtonText="Declino"
//         declineButtonStyle={{
//           background: "#6c757d",
//           color: "#ffffff",
//           borderRadius: "5px",
//           padding: "10px 20px",
//           fontWeight: "bold",
//         }}
//         enableDeclineButton={true}
//         onAccept={handleAccept}
//         onDecline={handleDecline}
//       >
//         <span>
//           Questo sito utilizza dei cookie essenziali per migliorare l'esperienza utente.{" "}
//           <a href="/privacy-policy" style={{ color: "#f4d03f" }}>
//             Scopri di più
//           </a>
//           . Puoi anche scegliere di abilitare i cookie di analisi.
//         </span>
//       </CookieConsent>

//       {/* Button to allow the user to reset cookie preferences */}
//       {cookiesAccepted && (
//         <div
//           onClick={resetCookiePreferences}
//           style={{
//             position: "fixed",
//             bottom: "10px",
//             right: "5%",
//             transform: "translateX(-50%)",
//             background: "rgba(0,0,0,0.7)",
//             color: "#ffffff",
//             padding: "10px 20px",
//             borderRadius: "5px",
//             cursor: "pointer",
//             zIndex: 1000,
//           }}
//         >
//           Cambia preferenza cookie
//         </div>
//       )}
//     </React.Fragment>
//   );
// }

// export default App;
import React, { useState, useEffect } from "react";
import Route from "./Routes/routeIndex";
import { CookieConsent } from "react-cookie-consent";
import "./assets/scss/theme.scss";
import { useNavigate } from "react-router-dom";

function App() {
  const navigate = useNavigate();
  // State to track cookie preferences
  const [cookiesAccepted, setCookiesAccepted] = useState(false);
  const [analyticsAccepted, setAnalyticsAccepted] = useState(true); // Default to true for analytics cookies
  const [showCookieManager, setShowCookieManager] = useState(false); // state to toggle cookie management

  // Function to set cookies using document.cookie
  const setCookie = (name, value) => {
    document.cookie = `${name}=${value}; path=/; max-age=31536000`; // max-age 1 year
  };

  const deleteCookie = (name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  };

  // Handle user consent
  const handleAccept = () => {
    setCookie("cookieConsent", "true");
    setCookie("analyticsConsent", analyticsAccepted ? "true" : "false");
    setCookiesAccepted(true);
  };

  const handleDecline = () => {
    setCookie("cookieConsent", "true");
    setCookie("analyticsConsent", "false");
    setCookiesAccepted(true);
    setAnalyticsAccepted(false);
  };

  const handleManageCookies = () => {
    setShowCookieManager(true); // Show the cookie management modal
  };

  const handleToggleAnalytics = () => {
    setAnalyticsAccepted(!analyticsAccepted);
    setCookie("analyticsConsent", !analyticsAccepted ? "true" : "false");
  };

  const handleResetCookies = () => {
    // Reset the cookies to show the banner again
    deleteCookie("tenergiaUserConsent"); // Delete the cookie used by react-cookie-consent
    deleteCookie("analyticsConsent");  // Delete the analytics consent cookie
    setCookiesAccepted(false); // Reset state to show banner
    setAnalyticsAccepted(true); // Reset analytics consent to default "true"
  };

  useEffect(() => {
    // Check if cookies are already accepted by checking cookies
    const storedConsent = document.cookie.split("; ").find(row => row.startsWith("tenergiaUserConsent"));
    const storedAnalytics = document.cookie.split("; ").find(row => row.startsWith("analyticsConsent"));

    if (storedConsent) {
      setCookiesAccepted(true);
    }

    if (storedAnalytics) {
      setAnalyticsAccepted(storedAnalytics.split("=")[1] === "true");
    }
  }, []);

  return (
    <React.Fragment>
      <Route />

      {/* The Cookie Consent Banner */}
      {!cookiesAccepted && (
        <CookieConsent
          location="bottom"
          style={{
            background: "#161c2d",
            color: "#ffffff",
            padding: "20px",
            fontSize: "16px",
          }}
          buttonStyle={{
            background: "#5F9300",
            color: "black",
            borderRadius: "5px",
            padding: "10px 20px",
            fontWeight: "bold",
          }}
          cookieName="tenergiaUserConsent"  // This is the cookie name that the component uses
          expires={1} // Cookie expires in 1 day
          buttonText="Accetto"
          declineButtonText="Declino"
          declineButtonStyle={{
            background: "#6c757d",
            color: "#ffffff",
            borderRadius: "5px",
            padding: "10px 20px",
            fontWeight: "bold",
          }}
          enableDeclineButton={false} // Hide the decline button, we'll manage cookies manually
          onAccept={handleAccept}
          onDecline={handleDecline}
        >
          <span>
            Questo sito utilizza dei cookie essenziali per migliorare l'esperienza utente.{" "}
            <a href="/privacy-policy" style={{ color: "#5F9300" }}>
              Scopri di più
            </a>
            . Puoi anche scegliere di abilitare i cookie di analisi.
          </span>

          {/* Button to manage cookie preferences inside the banner */}
          <div
            onClick={handleManageCookies}
            style={{
              marginTop: "10px",
              cursor: "pointer",
              color:"#5F9300",
              fontWeight: "bold",
              textDecoration: "underline",
            }}
          >
            Gestisci preferenze cookie
          </div>
        </CookieConsent>
      )}

      {/* "Gestisci preferenze cookie" button outside the banner */}
      {cookiesAccepted && (
        <div
          onClick={handleResetCookies}
          style={{
            position: "fixed",
            bottom: "10px",
            right: "5%",
            background: "rgba(0,0,0,0.7)",
            color: "#ffffff",
            padding: "10px 20px",
            borderRadius: "5px",
            cursor: "pointer",
            zIndex: 1000,
          }}
        >
          Reimposta preferenza cookie
        </div>
      )}

      {/* Cookie Preferences Modal */}
      {showCookieManager && (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            padding: "20px",
            boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
            borderRadius: "5px",
            zIndex: 1001,
          }}
        >
          <h3>Gestisci le tue preferenze sui cookie</h3>

          {/* Essential Cookies - Always enabled, cannot be toggled */}
          <div style={{ marginBottom: "10px", color: "#555" }}>
            <label>
              <input
                type="checkbox"
                checked={true}
                disabled
              />
              Cookie essenziali (sempre abilitati)
            </label>
          </div>

          {/* Analytics Cookies - Can be toggled */}
          <div>
            <label>
              <input
                type="checkbox"
                checked={analyticsAccepted}
                onChange={handleToggleAnalytics}
              />
              Accetta cookie analitici
            </label>
          </div>

          <div style={{ marginTop: "20px" }}>
            <button
              onClick={() => setShowCookieManager(false)} // Close the modal
              style={{
                backgroundColor: "#5F9300",
                padding: "10px 20px",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                fontWeight: "bold",
              }}
            >
              Chiudi
            </button>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default App;



